import { render, staticRenderFns } from "./SearchStatDetail.vue?vue&type=template&id=fddfcaea&scoped=true"
import script from "./SearchStatDetail.vue?vue&type=script&lang=js"
export * from "./SearchStatDetail.vue?vue&type=script&lang=js"
import style0 from "./SearchStatDetail.vue?vue&type=style&index=0&id=fddfcaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddfcaea",
  null
  
)

export default component.exports